import React from "react";
import { Outlet } from "react-router-dom";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { SmoothScroll } from "@/components/SmoothScroll";
import { ScrollToTop } from "@/components/ScrollToTop";
import { StickyContactBar } from "@/components/StickyContactBar";
import { Toaster } from "@/components/ui/sonner";

export const Layout = () => {
  return (
    <SmoothScroll>
      <ScrollToTop />
      <div className="min-h-screen bg-black text-white antialiased selection:bg-amber-500 selection:text-black">
        {/* Grain overlay */}
        <div
          className="pointer-events-none fixed inset-0 z-[1] opacity-[0.06] mix-blend-overlay"
          style={{
            backgroundImage:
              'url("data:image/svg+xml;utf8,<svg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22><filter id=%22n%22><feTurbulence type=%22fractalNoise%22 baseFrequency=%220.9%22 numOctaves=%221%22 stitchTiles=%22stitch%22/></filter><rect width=%22200%22 height=%22200%22 filter=%22url(%23n)%22 opacity=%220.85%22/></svg>")',
          }}
        />
        <Nav />
        <main className="relative z-[2] pt-[108px] pb-[56px] md:pb-[64px]">
          <Outlet />
        </main>
        <Footer />
        <StickyContactBar />
        <Toaster theme="dark" position="top-right" />
      </div>
    </SmoothScroll>
  );
};
